import { Col, Row } from "antd";
import moment from "moment";

import { CalendarHeaderTypo } from "./index.styled";
import { Next, Prevoius } from "../../Icon";

interface CalendarHeaderProps {
  value: moment.Moment | undefined;
  onChange: (date: moment.Moment) => void;
}

/**
 * 달력 헤더 커스텀 (antd-calendar)
 * @param param0
 * @returns
 */
export const CalendarHeader: React.FC<CalendarHeaderProps> = ({
  value,
  onChange,
}) => {
  return (
    <Row gutter={8} justify="center" align="middle">
      <Col>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Prevoius
            width={24}
            height={24}
            onClick={() => onChange(moment(value).add(-1, "month"))}
          />
        </div>
      </Col>
      <Col>
        <CalendarHeaderTypo>
          {moment(value).format("YYYY. MM")}
        </CalendarHeaderTypo>
      </Col>
      <Col>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Next
            width={24}
            height={24}
            onClick={() => onChange(moment(value).add(1, "month"))}
          />
        </div>
      </Col>
    </Row>
  );
};
